import type { FAQItem } from './types';

export const dataFAQs: FAQItem[] = [
  {
    id: 'backups-dr',
    question: 'Do you keep backups and how fast can you recover?',
    answer: `A formal backup and disaster recovery program, including defined RPO/RTO commitments, is a design goal and not built or contracted today. Hosting infrastructure has standard provider-level redundancy, but there is no dedicated backup product, no snapshot schedule, and no documented recovery time commitment yet. Ask us for current status before relying on a specific recovery timeline for planning.`,
    category: 'data',
  },
  {
    id: 'data-access-model',
    question: 'Who at ToolboxLogic can access our data and why?',
    answer: `Access follows **least-privilege** principles:

• Day-to-day operations do not require ToolboxLogic staff to view resident PII
• Support engineers may receive **time-limited, audited** access when you open a support ticket
• Access is role-gated and logged; approvals are required for elevated access

This is the intended access model for a production deployment; formal audit logging and access review tooling are still being built.`,
    category: 'data',
  },
  {
    id: 'data-deletion-backups',
    question: 'If we request deletion, what about backups?',
    answer: `Upon a verified deletion request, primary data is deleted promptly. There is no separate backup archive today, so there is nothing further to purge on a delayed schedule. A formal backup retention and accelerated-purge process is planned once a backup system is built. Ask us for current status before assuming a specific backup retention window.`,
    category: 'data',
  },
];
